export default __webpack_public_path__ + "static/media/IMG_20230718_183706 - Asmita Singh.af9b5f89.jpg";